import { PREDICAMENT_STATE_YES } from "core/consts";
import { ICD_CODE_CHARACTER_LIMIT } from "core/schemas/shared";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { padding, sizing } from "ds_legacy/materials/metrics";
import {
  Section,
  SectionRow,
  TextInputWithLabel,
  YesNoRadioWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionThree = () => {
  const translations = useTranslations();

  return (
    <Section
      title={translations.patientForms.drvMedicalForm.sectionThree.title}
    >
      <YesNoRadioWithLabel
        elementName="secondary_diagnosis_selected"
        label={
          translations.patientForms.drvMedicalForm.sectionThree
            .descriptionIllnessess
        }
        shouldStartWithNo
        sideMutation={(_value, mutate) => {
          mutate(null, "icd_code_2_code");
          mutate(null, "icd_code_3_code");
          mutate(null, "secondary_diagnosis");
        }}
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <VerticalLayout
              gap={sizing(1)}
              padding={padding(0, 0, 1)}
              width="100%"
            >
              <SectionRow>
                <TextInputWithLabel
                  characterLimit={ICD_CODE_CHARACTER_LIMIT}
                  elementName="icd_code_2_code"
                  isBold
                  isLarge
                  label={
                    translations.patientForms.drvMedicalForm.sectionThree
                      .diagnosisIcd
                  }
                  withFlatModel
                />
              </SectionRow>
              <SectionRow>
                <TextInputWithLabel
                  characterLimit={ICD_CODE_CHARACTER_LIMIT}
                  elementName="icd_code_3_code"
                  isBold
                  isLarge
                  label={
                    translations.patientForms.drvMedicalForm.sectionThree
                      .diagnosisIcd
                  }
                  withFlatModel
                />
              </SectionRow>
              <SectionRow>
                <TextInputWithLabel
                  elementName="secondary_diagnosis"
                  isBold
                  isLarge
                  label={
                    translations.patientForms.drvMedicalForm.sectionThree
                      .nyhaStages
                  }
                  withFlatModel
                />
              </SectionRow>
            </VerticalLayout>
          ),
        }}
      />
    </Section>
  );
};
